// Names the part type selector by category. Shared by Output.js and MobileWorkspace.js
// so the desktop and phone labels can't drift. "Liner Type" is masonry-only — a Class A
// chimney is not a liner.

const LABELS = {
  'pipe-straight': 'Stove Pipe Type',
  'chimney-straight': 'Chimney Type',
  'masonry-straight': 'Liner Type',
};

const CATEGORY_LABELS = {
  stove_pipe: 'Stove Pipe Type',
  chimney: 'Chimney Type',
  masonry: 'Liner Type',
};

const CATEGORY_NOUNS = {
  stove_pipe: 'stove pipe',
  chimney: 'chimney',
  masonry: 'lined masonry',
};

export function ventTypeLabel(componentType) {
  return LABELS[componentType] || 'Vent Type';
}

export function categoryTypeLabel(category) {
  return CATEGORY_LABELS[category] || 'Vent Type';
}

export function categoryNoun(category) {
  return CATEGORY_NOUNS[category] || 'vent';
}

export function ventTypePlaceholder(componentType) {
  return `— Choose ${ventTypeLabel(componentType).toLowerCase()} —`;
}
